import type { RootState } from '../store';

export const stepSelector = (state: RootState) => state.progressBar.step;
